export default "<div class=\"row\">\r\n    <div class=\"col-12\">\r\n        <ng-template app-content-host></ng-template>\r\n    </div>\r\n</div>";